/**
 * adapters/analyseFitAdapter.js — RC 1.53 Phase 4.1 STUB
 *
 * Phase 4.1 scope: stub interface only. Phase 4.3 will fill the body
 * by wrapping `lib/analyseFitPolling.js::runAnalyzeFitWithPolling`
 * verbatim and preserving the `inflight-fit:${userId}:${jobId}`
 * marker + URL-driven rebind contract.
 */

export const ACTION_CODE = 'analyse_fit';

export async function run(/* { body, options, signal, callbacks } */) {
  throw new Error(
    'analyseFitAdapter.run: not yet implemented (Phase 4.3). '
    + 'Phase 4.1 is skeleton-only.',
  );
}

export const PHASE_4_3_TODO = Object.freeze({
  wrap_polling_helper: 'lib/analyseFitPolling.js::runAnalyzeFitWithPolling',
  url_param_contract:  ['analyse_fit_run_id={id} (synthesised from analyse_runs)'],
  inflight_marker_key: 'inflight-fit:${userId}:${jobId}',
  cache_invalidations: ['analyse_fit', 'best_fit'],
  side_effects_on_complete: [
    'creditsContext.refresh()',
    'emit operation:complete',
    'emit pack:artefact_ready (analyse_fit)',
  ],
});
